import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import { Home } from './home/Home';
import Setting from './setting/Setting';
import { Review } from './preview/Preview';
import { Welcome } from './welcome/Welcome';
import { initApp } from '../actions';
import { connect } from 'react-redux';

interface OwnProps {
  id: string;
}
function _Router({ id, dispatch }: { id: string; dispatch: Cockpit.dispatch }) {
  const isPreview = window.location.pathname.startsWith('/preview');
  // inited: 0初始化 1欢迎页面 2正常显示
  const [inited, setInit] = useState(0);
  useEffect(() => {
    dispatch(initApp(id)).then(() => {
      setInit(1);
      setTimeout(() => setInit(2), 3e3);
    });
  }, []);

  if (!inited) return null;

  if (isPreview)
    return (
      <Router>
        <div>
          <Route exact path={`/preview/:url`} render={({ match }) => <Review url={window.decodeURIComponent(match.params.url)} />}></Route>
        </div>
      </Router>
    );

  if (inited === 1)
    return (
      <div onClick={() => setInit(2)}>
        <Welcome />
      </div>
    );

  return (
    <Router>
      <div>
        <Route
          render={({ location }) => {
            return (
              <Switch>
                <Route path={`/:id/setting`} component={Setting}></Route>
                <Route component={Home}></Route>
              </Switch>
            );
          }}
        ></Route>
      </div>
    </Router>
  );
}
export default connect<any, any, any>(null, null)(_Router);
